import { Map2D } from "@kosmod/kit";
import * as three from 'three';
import { Space2DInterface } from "../lib/space";
import { WalkableNode } from "../components/TerrainSystems/terrain";
import { ChunkMap, ReadonlyChunkMap } from "@kosmod/stew";

const DIRECTIONS = (x: number, y: number) => ({
  U: { x, y: y - 1 },
  D: { x, y: y + 1 },
  L: { x: x - 1, y },
  R: { x: x + 1, y },
})

export const findPath = (
  walkable: ReadonlyChunkMap<WalkableNode | null>,
  start: three.Vector2,
  target: three.Vector2
) => {
  if (start.equals(target))
    return [start];

  const frontier: { x: number, y: number, from: three.Vector2 }[] = [];
  const cameFrom = new Map2D<number, number, three.Vector2 | null>();

  const visitTile = (x: number, y: number, from: three.Vector2 | null) => {
    if (cameFrom.has(x, y))
      return;

    cameFrom.set(x, y, from);
    const v = walkable.read(x, y);
    if (!v)
      return;
    const d = DIRECTIONS(x, y);
    const newFrom =  new three.Vector2(x, y);
    if (v.U)
      frontier.push({ ...d.U, from: newFrom })
    if (v.D)
      frontier.push({ ...d.D, from: newFrom })
    if (v.L)
      frontier.push({ ...d.L, from: newFrom })
    if (v.R)
      frontier.push({ ...d.R, from: newFrom })
  }
  
  visitTile(start.x, start.y, null);

  while (frontier.length > 0) {
    const candidate = frontier.shift();
    if (!candidate)
      throw new Error();

    if (candidate.x === target.x && candidate.y === target.y) {
      let from: three.Vector2 | null = candidate.from;

      // actually we are here
      const path: three.Vector2[] = [target];
      while (from !== null) {
        path.push(from);
        from = cameFrom.get(from.x, from.y);
      }
      return path.toReversed();
    }

    visitTile(candidate.x, candidate.y, candidate.from);
  }


  // No path found
  return null;
}